import { getConfig } from "@jti/fe-common";
import type { IrsApiContract } from "@jti/rest-api-types";

import { getUser } from "../../utils";
import { getIsEvo } from "../../utils/evo";

import { IrsApiEvo } from "./IrsApiEvo";
import { IrsApiLegacy } from "./IrsApiLegacy";

/**
 * IRS - Inventory Registration Service
 */
export class IrsApi {
  static init(): IrsApiContract {
    const config = getConfig();

    if (config.USE_EVO_ONLY) {
      return new IrsApiEvo(config.EVO_DOMAIN, config.EVO_TENANT, config["X-RECAPTCHA-ID"]);
    }

    if (getIsEvo(config.IRS_URL)) {
      return new IrsApiEvo(config.IRS_URL, config.IRS_X_DES_AK_TENANT_TOKEN, config["X-RECAPTCHA-ID"]);
    }

    const user = getUser();

    return new IrsApiLegacy(config.IRS_URL, config.IRS_X_DES_AK_TENANT_TOKEN, user.ciam_token);
  }
}
